/* eslint-disable max-len */
import { CloudServices } from 'ckeditor5'
import {
  Comments,
  PresenceList,
  RealTimeCollaborativeComments,
  RealTimeCollaborativeEditing,
  RealTimeCollaborativeRevisionHistory,
  RealTimeCollaborativeTrackChanges,
  RevisionHistory,
  TrackChanges,
} from 'ckeditor5-premium-features'

export type RealTimePluginName =
  | 'CloudServices'
  | 'Comments'
  | 'PresenceList'
  | 'RealTimeCollaborativeComments'
  | 'RealTimeCollaborativeEditing'
  | 'RealTimeCollaborativeRevisionHistory'
  | 'RealTimeCollaborativeTrackChanges'
  | 'RevisionHistory'
  | 'TrackChanges'

export {
  CloudServices,
  Comments,
  PresenceList,
  RealTimeCollaborativeComments,
  RealTimeCollaborativeEditing,
  RealTimeCollaborativeRevisionHistory,
  RealTimeCollaborativeTrackChanges,
  RevisionHistory,
  TrackChanges,
}

export const RealTimeCollaborationPluginNames: RealTimePluginName[] = [
  'CloudServices',
  'Comments',
  'PresenceList',
  'RealTimeCollaborativeComments',
  'RealTimeCollaborativeEditing',
  'RealTimeCollaborativeRevisionHistory',
  'RealTimeCollaborativeTrackChanges',
  'RevisionHistory',
  'TrackChanges',
]

export const RealTimeCollaborationPlugins = [
  CloudServices,
  Comments,
  PresenceList,
  RealTimeCollaborativeComments,
  RealTimeCollaborativeEditing,
  RealTimeCollaborativeRevisionHistory,
  RealTimeCollaborativeTrackChanges,
  RevisionHistory,
  TrackChanges,
]
